<template>
  <form-template
    :data="data"
    :blocks="blocks"
    :snackbar="snackbar"
    title="Изображение"
    @save="save"
  >
    <v-file-input accept="image/*" label="Изображение" @change="imageUpload" />
    <img
      v-if="override.content"
      width="100%"
      :src="override.content"
      alt=""
    />
  </form-template>
</template>

<script>
import formMixin from "./formMixin";
import FormTemplate from "./Template";
import readBase64 from "../../../mixins/readBase64";

export default {
  name: "FormImage",
  components: { FormTemplate },
  mixins: [formMixin, readBase64],
  data() {
    return {
      override: {
        content: this.data.content
      }
    };
  },
  methods: {
    imageUpload(file) {
      this.readBase64(file).then((image) => {
        this.override.content = image;
      });
    }
  }
};
</script>
